export const LIST_CATEGORIES_COLUMNS = [
  {
    id: 'title',
    displayName: 'Parent Category',
  },
  {
    id: 'id',
    displayName: 'Kode',
  },
  {
    id: 'subCategoryTitle',
    displayName: 'Sub Category',
  },
  {
    id: 'subCategoryId',
    displayName: 'Kode',
  },
  {
    id: 'childCategoryTitle',
    displayName: 'Child Category',
  },
  {
    id: 'childCategoryId',
    displayName: 'Kode',
  },
];

export const LIST_BRANDS_COLUMNS = [
  {
    id: 'title',
    displayName: 'Brand',
  },
  {
    id: 'id',
    displayName: 'Kode',
  },
];

export const LIST_PRODUCTS_COLUMNS = (arrayWarehouse) => [
  {
    id: 'no',
    displayName: 'no',
  },
  {
    id: 'sku',
    displayName: 'sku',
  },
  {
    id: 'title',
    displayName: 'title',
  },
  {
    id: 'status',
    displayName: 'status',
  },
  {
    id: 'price',
    displayName: 'price',
  },
  ...arrayWarehouse,
  {
    id: 'installable',
    displayName: 'installable',
  },
  {
    id: 'installation_fee',
    displayName: 'installation price',
  },
  {
    id: 'rented',
    displayName: 'rented',
  },
  {
    id: 'rent_pricing',
    displayName: 'rent price',
  },
];

export const TEMPLATES_PRODUCT = [
  {
    name: 'Bulk Create',
    template:
      'https://homestory-production-assets.s3.ap-southeast-1.amazonaws.com/product/TEMPLATE_CREATE_BULK_PRODUCT.xlsx',
  },
  {
    name: 'Bulk Update',
    template:
      'https://homestory-production-assets.s3.ap-southeast-1.amazonaws.com/product/TEMPLATE_UPDATE_BULK_PRODUCT.xlsx',
  },
  {
    name: 'Bulk Discount',
    template:
      'https://homestory-staging-assets.s3.ap-southeast-1.amazonaws.com/product/TEMPLATE_BULK_DISCOUNTS.xlsx',
  },
  {
    name: 'Upload Keyword',
    template:
      'https://homestory-staging-assets.s3.ap-southeast-1.amazonaws.com/product/Keyword+CSV+Template.xlsx',
  },
];
